export default __webpack_public_path__ + "static/media/team-4.d0b999c9.png";